import type { ProfileValues } from '../../products/productDetail/levelFromSprint';

/** Only a new level or chapter counts: clearing one leaves every product as it is. */
export const profileChange = (
  next: { level?: string; chapter?: string },
  current: { level?: string; chapter?: string },
): ProfileValues => ({
  level: next.level && next.level !== current.level ? next.level : undefined,
  chapter: next.chapter && next.chapter !== current.chapter ? next.chapter : undefined,
});

/** The suffix of the dialog's title and body keys: the level alone has none. */
export const changeKind = (change: ProfileValues): '' | 'Chapter' | 'Both' => {
  if (change.chapter === undefined) return '';
  return change.level === undefined ? 'Chapter' : 'Both';
};

/** What every product keeps before a save: a level or chapter about to change, cleared ones included. */
export const keptBeforeSave = (
  next: { level?: string; chapter?: string },
  current: { level?: string; chapter?: string },
): { level?: string; chapter: boolean } | null => {
  const level = next.level !== current.level ? (current.level ?? '') : undefined;
  const chapter = next.chapter !== current.chapter;
  return level !== undefined || chapter ? { level, chapter } : null;
};
